export default {
    nameFirst: {
        "ui:autocomplete": "disabled"
    },
    nameMiddle: {
        "ui:autocomplete": "disabled"
    },
    nameLast: {
        "ui:autocomplete": "disabled"
    },
    emailPrimary: {
        "ui:autocomplete": "disabled"
    },
    emailAlternate: {
        "ui:autocomplete": "disabled"
    },
    dateOfDeath: {
        "ui:widget": "hidden",
    },
    dateOfBirth: {
        "ui:widget": "customDate"
    },
    effectiveDate: {
        "ui:widget": "customDate"
    },
    previousSmokerQuitDate: {
        "ui:widget": "customDate"
    },
    isUSCitizen: {
        "ui:widget": "radio"
    },
    isUSResident: {
        "ui:widget": "radio"
    },
    isDisabled: {
        "ui:widget": "radio"
    },
    isMedicareEligible: {
        "ui:widget": "radio"
    },
    isFullTimeCollegeStudent: {
        "ui:widget": "radio"
    },
    isCurrentSmoker: {
        "ui:widget": "radio"
    },
    isPreviousSmoker: {
        "ui:widget": "radio"
    },
    heightInInches: {
        "ui:widget": "hidden"
    },
    weightInPounds: {
        "ui:widget": "hidden"
    },
    usSocialSecurityNumber: {
        "ui:widget": "formatSSN"
    }
};